import React from "react";

export function HeadingTitle(props: { children: React.ReactNode }) {
  return <p className="title is-4 has-text-centered">{props.children}</p>;
}
